module.exports = window.dnn.nodeModules.ReactModal;